import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import ImageListItem from "@mui/material/ImageListItem";
import Box from "@mui/material/Box";

import ImageGalleryList from "./ImageGalleryList";
import HoverImage from "./HoverImage";
import ClickAlert from "./ClickAlert";

const images = [
  "img1.jpg", "img2.jpg", "img3.jpg", "img4.jpg",
  "img5.jpg", "img6.jpg", "img7.jpg", "img8.jpg"
];

function Demo() {
  return (
    <Box
      sx={{
        backgroundColor: "background.default", 
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: '100%'
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          my: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Container maxWidth="md" sx={{ mb: 4, textAlign: "justify" }}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }}>
            DIVERGENT PERCEPTION GALLERY
          </Typography>
          <Typography>
            Explore how our SEEME framework interprets ambiguous natural forms into art. 
            <strong> Hover</strong> on any image to view its extracted silhouette mask. 
            <strong> Click</strong> on the image to perform a side-by-side comparison between 
            the appearance-driven <em>Visual-RAG</em> strategy and the cognitively-guided <em>Semantic-RAG</em> strategy.
          </Typography>
          <ClickAlert />
        </Container>
        
        <ImageGalleryList>
          {images.map((item) => (
            <ImageListItem key={item}>
              <HoverImage
                srcInput={`/images/inputs/${item}`}
                srcMask={`/images/masks/${item}`}
                srcVisualRAG={`/images/visual_rag/${item}`}
                srcSemanticRAG={`/images/semantic_rag/${item}`}
              />
            </ImageListItem>
          ))}
        </ImageGalleryList>
      </Container>
    </Box>
  );
}

export default Demo;